import { all } from 'redux-saga/effects';

import { addTableSagaWatcher } from './add_table.saga';
import { deleteTableSagaWatcher } from './delete_table.saga';
import { deleteTablesSagaWatcher } from './delete_tables.saga'
import { getTableSagaWatcher } from './get_table.saga';
import { getTablesSagaWatcher} from './get_tables.saga';
import { setTakeAwayTableSagaWatcher } from './set_takeaway_table.saga';
import { setTableSagaWatcher} from './set_table.saga';
import { unDeleteTableSagaWatcher } from './undelete_table.saga';
import { unDeleteTablesSagaWatcher } from './undelete_tables.saga';
import { updateTableSagaWatcher } from './update_table.saga';


export default function* tableSaga() {
    yield all([
        addTableSagaWatcher(),
        deleteTableSagaWatcher(),
        deleteTablesSagaWatcher(),
        getTableSagaWatcher(),
        getTablesSagaWatcher(),
        setTableSagaWatcher(),
        setTakeAwayTableSagaWatcher(),
        unDeleteTableSagaWatcher(),
        unDeleteTablesSagaWatcher(),
        updateTableSagaWatcher()
    ]);
}